export const removeInitialLoader = () => {
  const loader = document.getElementById('initial-casa-loader');
  if (loader) {
    loader.remove();
  }
};
